import { Box, Typography, Alert } from '@mui/material';
import { CodeEditor } from '../common/CodeEditor';
import type { ToolExecutionResult as ToolExecutionResultType } from '../../types/tool';

export interface ToolExecutionResultProps {
  result: ToolExecutionResultType | null;
}

/**
 * Displays the result of a tool execution or preview.
 */
export const ToolExecutionResult = ({ result }: ToolExecutionResultProps) => {
  if (!result) return null;

  return (
    <Box sx={{ mt: 2 }}>
      {!result.isSuccess ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {result.errorMessage || 'Tool execution failed'}
        </Alert>
      ) : (
        <Alert severity={result.isDryRun ? 'warning' : 'success'} sx={{ mb: 2 }}>
          {result.isDryRun ? 'Dry-run completed' : 'Execution completed'}
        </Alert>
      )}

      {result.impactPreviewJson && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            Impact preview
          </Typography>
          <CodeEditor value={result.impactPreviewJson} language="json" height="200px" readOnly />
        </Box>
      )}

      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Result
      </Typography>
      <CodeEditor value={result.result || ''} language="json" height="240px" readOnly />
    </Box>
  );
};

